module.exports = __webpack_public_path__ + "img/resource_hot.507fee6d.png";